import React, { type FC, type PropsWithChildren } from 'react';

import { Link } from '@lucid/components-react';
import { type Drupal_ParagraphIntegrationCta } from 'generated/drupal-graphql';
import type { Lucid } from 'types/types';
import type { IntegrationCtaInterface } from 'components/buttons/button.interface';

interface IntegrationCtaProps {
  displayAsButton?: boolean;
  asButton?: boolean;
  inverted?: boolean;
  variant?: Lucid.Component.Link['Variant'] | Lucid.Component.Button['Variant'];
}

const IntegrationCta: FC<PropsWithChildren<IntegrationCtaInterface & IntegrationCtaProps>> = ({
  displayAsButton,
  entity,
  className = '',
  variant,
}) => {
  const ctaEntity = entity as Drupal_ParagraphIntegrationCta;

  if (!ctaEntity.fieldCtaButtonLink) {
    return null;
  }

  return (
    <Link
      className={className}
      displayAsButton={displayAsButton}
      to={ctaEntity.fieldCtaButtonLink!}
      underline="hover"
      variant={variant}
    >
      {ctaEntity.fieldCtaButtonText}
    </Link>
  );
};

export default IntegrationCta;
